import {ColumnBar} from '..';
import {Header as H} from './Header'

import {OpenMenu} from './OpenMenu';

export const Header = Object.assign(H, {
  OpenMenu,
  ...ColumnBar
})
